import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import React from 'react'

import { Container, Icon } from './styles'

const PaperProps = {
    style: {
        backgroundColor: '#222222',
        width: '100%',
        height: '100%',
        padding: 0,
        margin: 0,
        borderRadius: 0,
        maxHeight: '100%',
        maxWidth: '100%',
    },
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const ReloadState = ({ isOpen, onClose, onClick }) => {
    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
            TransitionComponent={Transition}
            PaperProps={PaperProps}
        >
            <Container onClick={onClick}>
                <Icon src="assets/refresh.svg" />
                Oh! we have a problem. Please refresh the page.
            </Container>
        </Dialog>
    )
}

export default React.memo(ReloadState)
